import axios from '@/plugins/axios'

const purchase = async ({ productType, cardId, productId, customer, address, paymentMethod, amount = 0 }) => {
  try {
    const params = {
      product_type: productType,
      product_id: productId,
      card_id: cardId,
      customer: customer,
      address: address,
      payment_method: paymentMethod,
      amount: parseInt(amount * 100)
    }
    const response = await axios.post('purchase', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  purchase
}
